export enum SystemType {
    Website = 1,
    BackOffice = 2,
}